import { CanvasContext } from '@cog/ecs-canvas-2d-plugin'

import { world } from '../../../world'
import { BrickProps } from '../Components/Brick'

export const cleanupDeadBricks = (ctx: CanvasContext) => {
  world.deleteWhere([BrickProps], ([props]) => props.health <= 0)
}
